import React from 'react';
import clsx from 'clsx';

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  name?: string;
}

export const Slider: React.FC<SliderProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  className,
  name,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };

  // Calculate percentage for background gradient effect if needed, 
  // but accent-indigo-600 usually handles the active track color in modern browsers.
  
  return (
    <div className={clsx("relative flex items-center w-full h-6", className)}>
      <input
        type="range"
        name={name}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={clsx(
          "w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer",
          "accent-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/20",
          "[.theme-liquid-glass_&]:bg-white/10 [.theme-liquid-glass_&]:accent-violet-400",
          "[.theme-liquid-glass_&]:focus:ring-violet-400/30",
          disabled && "opacity-50 cursor-not-allowed accent-slate-400 [.theme-liquid-glass_&]:accent-white/40"
        )}
      />
    </div>
  );
};
